module.exports = __webpack_public_path__ + "static/img/profile.e79a8348.jpg";